import React from 'react';
import { isEmpty } from 'lodash';
import {
  FaqsBreadCrumbWrapper,
  FaqsBreadCrumbContainer,
  FaqsBreadCrumbRow,
  FaqsBreadCrumbText,
  FaqsBreadCrumbTextButton,
} from '../styles/Faqs.styled';
import { Button } from '../styles/Button.styled';

export default function FaqsBreadCrumb({ data, dir }) {
  return (
    <FaqsBreadCrumbWrapper className="smoothed">
      <FaqsBreadCrumbContainer>
        <FaqsBreadCrumbRow>
          <FaqsBreadCrumbText dir={dir}>{data.title}</FaqsBreadCrumbText>
          <FaqsBreadCrumbTextButton dir={dir}>
            <p>{data.description}</p>
            {isEmpty(data.link.url) || (
              <Button stylevariant="secondary" to={data.link.url} dir={dir}>
                {data.link.name}
              </Button>
            )}
          </FaqsBreadCrumbTextButton>
        </FaqsBreadCrumbRow>
      </FaqsBreadCrumbContainer>
    </FaqsBreadCrumbWrapper>
  );
}
